<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="serahaft"><a class="page" id="pii"></a><i>A Volume in the Series</i></p>
<p class="serahaft">Culture and Politics in the Cold War and Beyond</p>
<p class="serbh">E<span class="sm">DITED</span> <span class="sm">BY</span></p>
<p class="sered"><i>Edwin A. Martini</i></p>
<p class="sered"><i>and</i></p>
<p class="sered"><i>Scott Laderman</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma-CAPUTI-0003.vue?95914e7a